import React, { useState, useImperativeHandle, forwardRef, useRef } from 'react';
import styled from 'styled-components';

const InfoInput = forwardRef((props, ref) => {
	const { column, defaultVal, setVal, className, type, width} = props;
	const [value, setValue] = useState(defaultVal);
	const [changed, setChanged] = useState(false);

	const inputRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		}
	}));

	function handleChange(e) {
		setValue(e.target.value);
		setVal(e.target.value);
		setChanged(true);
	}

	function handleFocus(e) {
		if (!changed) {
			setValue("");
		}
	}

  return (
    <TopLevelWrapper>
      <Column>{column}</Column>
      <Input
        ref={inputRef}
        type={type}
        value={value}
				width={width}
        className={`${className} ${changed ? "changed" : ""}`}
        onChange={handleChange}
        onFocus={handleFocus} />
    </TopLevelWrapper>
  )
});

export default InfoInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const Column = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	
	margin-top: 8px;
	padding: 0 8px 0 8px;

	outline: none;
	border: 1px solid ${props => props.theme.line};
	border-radius: 8px;
	background-color: ${props => props.theme.subBackground};
	color: ${props => props.theme.text};

	width: ${props => props.width}px;
	height: 30px;

	::placeholder {
		color: ${props => props.theme.gray};
	}
`;